import { IBaseWidget } from '../../schema/widgets/IBaseWidget';
import { hasCode } from '../../schema/widgets/ICodeWidget';

/**
 * Costruisce il nome del widget così come viene utilizzato nel form.
 */
export function getWidgetName<W extends IBaseWidget & { id: string }>(
  widget: W,
) {
  return hasCode(widget) && widget.code ? widget.code : widget.id;
}
